module.exports = __webpack_public_path__ + "static/media/magnifier_white.85208973.svg";